<div class="machine-documents-step">
  <p class="machine-documents-step-title" translate>
    To attach a document to the machine, upload a file by dragging and dropping it into the
    highlighted section or select a document from the document pool.
  </p>
  <rotec-form-v2
    [form]="stepForm"
    (formChange)="stepForm = $event"
    [fields]="documentsFields"
    [model]="machineTaskModel"
    (modelChange)="machineTaskModelChange.emit($event)"
  ></rotec-form-v2>
</div>
